<template>
  <search-group title="预订单查询" @search="findData" @clear="clearValue" :span="24" :btnOffset="18" :btnSpan="6" :multipleLines="true" :inline="true" >
    <Row class="mb16" :gutter="16">
      <Col span="5">
        <Select v-model="searchData.projectFid" placeholder="项目名称" >
          <Option value=''>请选择</Option>
          <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select v-model="searchData.source" placeholder="预订方式">
          <Option value=''>请选择</Option>
          <Option v-for="item in conditionForList.reservationSource" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.reservationStatus" placeholder="预订单状态">
          <Option value=''>请选择</Option>
          <Option v-for="item in conditionForList.reservationStatus" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.userType" placeholder="客户类型">
          <Option value=''>请选择</Option>
          <Option v-for="item in conditionForList.customerType" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.rentType" placeholder="租约类型">
          <Option value=''>请选择</Option>
          <Option v-for="item in conditionForList.rentType" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
    <Row :gutter="16" class="mb16">
      <Col span="5">
        <DatePicker style="width:100%" v-model="searchData.reservationDateList" split-panels type="daterange" format="yyyy-MM-dd" placeholder="预订日期范围"></DatePicker>
      </Col>
      <Col span="5">
        <DatePicker style="width:100%" v-model="searchData.reservationSignList" split-panels type="daterange" format="yyyy-MM-dd" placeholder="预计签约日期范围"></DatePicker>
      </Col>
      <Col span="5">
        <DatePicker style="width:100%"  v-model="searchData.reservationPreSignList" split-panels type="daterange" format="yyyy-MM-dd" placeholder="预计起租日期范围"></DatePicker>
      </Col>
      <Col span="5">
        <DatePicker style="width:100%" v-model="searchData.contractEndList"  split-panels type="daterange" format="yyyy-MM-dd" placeholder="预计到期日期范围"></DatePicker>
      </Col>
      <Col span="4">
        <Input style="width: 100%" class="width3" type="text" v-model="searchData.q"  placeholder="客户名称、手机号、预订单号、房间号" ></Input>
      </Col>
    </Row>
    <Row :gutter="16">
      <Input class="width3" style="visibility: hidden" type="text"></Input>
    </Row>
  </search-group>
</template>

<script type="text/ecmascript-6">
  import {getProjects } from 'api/common'
  import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "../../../../../utils/format";
  import {conditionForList} from "../../../../../api/book";

  export default {
    components: {
      SearchGroup
    },
    created(){
      getProjects().then( res => {
        this.projectList = res.data
      }).catch(error=>{})

      conditionForList().then(res=>{
        if(!res.data){
          return
        }
        this.conditionForList=res.data

      }).catch(error=>{})


    },
    mounted(){
      this.$emit('searchData', this.searchDataComputed);
    },
    computed:{
      searchDataComputed(){
        function f(data) {
          return data?formatDateTime(data, false):''
        }

        return {
          "rentEndDate": null,
          "rentStartDate": null,

          "projectFid": this.searchData.projectFid,
          "q": this.searchData.q,
          "rentType": this.searchData.rentType,
          "createTimeStart":f(this.searchData.reservationDateList[0]),
          "createTimeEnd":f(this.searchData.reservationDateList[1]),
          "reservationSignDateStart":f(this.searchData.reservationSignList[0]),
          "reservationSignDateEnd":f(this.searchData.reservationSignList[1]),
          "rentStartDateBegin":f(this.searchData.reservationPreSignList[0]),
          "rentStartDateEnd":f(this.searchData.reservationPreSignList[1]),
          "rentEndDateBegin":f(this.searchData.contractEndList[0]),
          "rentEndDateEnd":f(this.searchData.contractEndList[1]),
          "reservationStatus": this.searchData.reservationStatus,
          "userType": this.searchData.userType,
          "source": this.searchData.source,
        }
      }


    },
    data () {
      return {
        signDay:[],
        searchData: {
          "projectFid": null,
          "q": '',
          "rentType": null,
          "reservationStatus": null,
          "userType": null,
          reservationDateList:['',''],
          reservationSignList:['',''],
          reservationPreSignList:['',''],
          contractEndList:['',''],
          rentList:['','']
        },
        conditionForList:{
          customerType:[],
          rentType:[],
          reservationStatus:[]
        },
        projectList:[],
      }
    },
    methods: {
      findData() {
        this.$emit('searchData', this.searchDataComputed);
      },
      clearValue() {
        this.searchData={
          "projectFid": null,
          "q": '',
          "rentType": null,
          "reservationStatus": null,
          "userType": null,
          reservationDateList:['',''],
          reservationSignList:['',''],
          reservationPreSignList:['',''],
          contractEndList:['',''],
          rentList:['','']
        }
      },
    },
  }
</script>

<style scoped>
  .width3{
    width: 220px;
  }
</style>
